import { render } from "./g-data-page.vue?vue&type=template&id=32b02c90&ts=true"
import script from "./g-data-page.vue?vue&type=script&lang=tsx"
export * from "./g-data-page.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__